<template>
  <b-modal
    v-bind="$attrs"
    no-trap
    no-fade
    title="Confirm Save"
    ok-title="Save"
    :ok-disabled="!dateRangeValid"
    @ok="save"
    @cancel="cancel"
    centered
    no-header-close
    no-close-on-backdrop
    no-close-on-esc
  >
    <font-awesome-icon icon="circle-info" />
    You have changed the following fields which affect your organization’s existing time cards:
    <ul>
      <li v-for="field in fields" :key="field[1]">{{ field[1] }} </li>
    </ul>
    You can choose to retroactively update all your existing time cards with these changes,
    or only apply it to future time cards.<br/>
    <br/>
    <b-form-checkbox v-model="checked">
      Apply these changes retroactively<br/>
      <span class="disclaimer">* retroactive changes may take several minutes to update</span>
    </b-form-checkbox>
    <form-group
      v-if="checked && enableDenormDateRange"
      class="tw:mt-2" :state="dateRangeValid"
      invalid-feedback="End date must be equal or greater than Start date"
    >
      <template #label>
        Date range
        <help-text-icon>
          You can set the date range for which to apply these changes retroactively.
          For example, if you change the department, you might want to only apply it starting the beginning of this week, etc.
        </help-text-icon>
      </template>
      <div class="tw:flex tw:items-center">
        <date-picker v-model="denormStart" :insideBootstrapOverlay="true" size="small" class="tw:max-w-32 tw:mr-2" />
        &#8594;
        <date-picker v-model="denormEnd" :insideBootstrapOverlay="true" size="small" class="tw:max-w-32 tw:ml-2" />
      </div>
    </form-group>
  </b-modal>
</template>
<script>
import { computed, ref, watch } from 'vue'
import { useLocalSettingsStore } from '@/stores/localSettings'
import DatePicker from './DatePicker.vue'
import HelpTextIcon from './HelpTextIcon.vue'

export default {
  name: 'DenormPrompt',
  components: {
    DatePicker,
    HelpTextIcon
  },
  setup () {
    const localSettingsStore = useLocalSettingsStore()
    const checked = ref(localSettingsStore.defaultCrossIndexRetroactive)
    const denormStart = ref(null)
    const denormEnd = ref(null)
    const dateRangeValid = computed(() => !denormStart.value || !denormEnd.value || denormStart.value <= denormEnd.value)

    watch(
      () => localSettingsStore.defaultCrossIndexRetroactive,
      defaultCrossIndexRetroactive => {
        checked.value = defaultCrossIndexRetroactive
      }
    )

    return {
      checked,
      denormStart,
      denormEnd,
      dateRangeValid,
      localSettingsStore
    }
  },
  inheritAttrs: false,
  props: {
    fields: Array,
    enableDenormDateRange: Boolean
  },
  methods: {
    save () {
      const denorm = this.checked
      this.$emit('save', {
        denorm,
        denormStart: denorm ? this.denormStart : null,
        denormEnd: denorm ? this.denormEnd : null
      })
      this.denormStart = null
      this.denormEnd = null
    },
    cancel () {
      this.$emit('cancel')
      this.denormStart = null
      this.denormEnd = null
    }
  }
}
</script>
<style scoped>

  .disclaimer {
    font-style: italic;
    font-size: 0.75rem;
  }

</style>
